module.exports = __webpack_public_path__ + "static/img/gtkl@2x.434da94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ym/gtkl@2x.png
// module id = ZMcO
// module chunks = 1